import { isPlatformBrowser } from '@angular/common';
import { AfterViewInit, Directive, ElementRef, Injectable, Inject, Input, PLATFORM_ID } from '@angular/core';

// MRD - custom renderer as Renderer2 no longer supports invokeElementMethod
@Injectable({ providedIn: 'root'})
export class CustomRenderer {

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object
  ) { }

  invokeElementMethod(eleRef: ElementRef, method: string) {
    if (isPlatformBrowser(this.platformId)) {
      eleRef.nativeElement[method]();
    }
  }
}

// tslint:disable-next-line:directive-selector
@Directive({ selector: '[setFocus]' })
export class SetFocusDirective implements AfterViewInit {
 
  @Input('setFocus') isFocused: boolean;
 
  constructor(private hostElement: ElementRef, private renderer: CustomRenderer) {}

  ngAfterViewInit() {
    if (this.isFocused) {
      // MRD - use a timeout to get around matDialog stealing focus - we keep setting the focus at 100 second intervals
      setTimeout(() => { this.renderer.invokeElementMethod(this.hostElement, 'focus'); }, 100);
      setTimeout(() => { this.renderer.invokeElementMethod(this.hostElement, 'focus'); }, 200);
      setTimeout(() => { this.renderer.invokeElementMethod(this.hostElement, 'focus'); }, 300);
      setTimeout(() => { this.renderer.invokeElementMethod(this.hostElement, 'focus'); }, 400);
      setTimeout(() => { this.renderer.invokeElementMethod(this.hostElement, 'focus'); }, 500);
    }
  }
}
